var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMainLogoNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 385,
    viewBox: "0 0 301 385",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 97.6602V91.6502L91.6519 71.116V381.133H91.1511H0.5V380.882V97.6602Z",
    fill: "#132142",
    stroke: "#132142"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6.5083V50.0809L92.6536 29.5467V6.5083H92.1527H12.0192H0.5Z",
    fill: "#E0B32D",
    stroke: "#E0B32D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.211 26.0409V23.0359L216.36 1.5V83.6369H300.5V158.762H299.999H218.363V279.463C218.363 306.008 246.939 315.81 298.998 301.5V374.622C218.464 398.849 127.211 380.131 127.211 297.712C127.211 215.294 127.211 226.876 127.211 226.876V182.802V172.879V132.562V26.0409Z",
    fill: "#132142",
    stroke: "#132142"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogoNew);
export default __webpack_public_path__ + "static/media/mainLogoNew.4f1e5bf6cc84a6d4358fbb122e316919.svg";
export { ForwardRef as ReactComponent };